import { render, staticRenderFns } from "./restriction-modal-view.vue?vue&type=template&id=7f6bf6f6"
import script from "./restriction-modal-view.vue?vue&type=script&lang=js"
export * from "./restriction-modal-view.vue?vue&type=script&lang=js"
import style0 from "./restriction-modal-view.vue?vue&type=style&index=0&id=7f6bf6f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports